import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./CriarFolga.css";

const API_URL = "https://acesso.cronosagenda.com.br/api";

const CriarFolga = () => {
    const [data, setData] = useState("");
    const [funcionarioId, setFuncionarioId] = useState("");
    const [funcionarios, setFuncionarios] = useState([]);
    const [mensagem, setMensagem] = useState("");
    const [tipoMensagem, setTipoMensagem] = useState("");
    const [carregando, setCarregando] = useState(false);
    const [carregandoFuncionarios, setCarregandoFuncionarios] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        let ativo = true;

        const carregarFuncionarios = async () => {
            try {
                setCarregandoFuncionarios(true);

                await axios.get(`${API_URL}/verificar-autenticacao`, {
                    withCredentials: true,
                });

                const response = await axios.get(`${API_URL}/funcionarios`, {
                    withCredentials: true,
                });

                if (ativo) {
                    setFuncionarios(response.data || []);
                }
            } catch (error) {
                console.error("Erro ao carregar funcionários:", error);

                if (!ativo) return;

                if (
                    error.response?.status === 401 ||
                    error.response?.status === 403
                ) {
                    navigate("/login");
                    return;
                }

                setMensagem("Não foi possível carregar os funcionários.");
                setTipoMensagem("erro");
            } finally {
                if (ativo) {
                    setCarregandoFuncionarios(false);
                }
            }
        };

        carregarFuncionarios();

        // Mantém os bloqueios que já existiam no componente.
        const bloquearInspecao = (event) => {
            if (
                event.key === "F12" ||
                (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === "i") ||
                (event.ctrlKey && event.key.toLowerCase() === "u")
            ) {
                event.preventDefault();
            }
        };

        const bloquearCliqueDireito = (event) => {
            event.preventDefault();
        };

        document.addEventListener("keydown", bloquearInspecao);
        document.addEventListener("contextmenu", bloquearCliqueDireito);

        return () => {
            ativo = false;
            document.removeEventListener("keydown", bloquearInspecao);
            document.removeEventListener("contextmenu", bloquearCliqueDireito);
        };
    }, [navigate]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        setMensagem("");
        setTipoMensagem("");

        if (!data) {
            setMensagem("Selecione a data da folga.");
            setTipoMensagem("erro");
            return;
        }

        // Compara datas no formato local YYYY-MM-DD, evitando
        // diferenças de fuso horário causadas por toISOString().
        const hoje = new Date();
        const ano = hoje.getFullYear();
        const mes = String(hoje.getMonth() + 1).padStart(2, "0");
        const dia = String(hoje.getDate()).padStart(2, "0");
        const dataAtual = `${ano}-${mes}-${dia}`;

        if (data < dataAtual) {
            setMensagem("A data da folga não pode ser no passado.");
            setTipoMensagem("erro");
            return;
        }

        setCarregando(true);

        try {
            const payload = {
                data,
                funcionario_id: funcionarioId || null,
            };

            const response = await axios.post(
                `${API_URL}/folgas`,
                payload,
                { withCredentials: true }
            );

            setMensagem(response.data?.message || "Folga criada com sucesso!");
            setTipoMensagem("sucesso");
            setData("");
            setFuncionarioId("");
        } catch (error) {
            console.error("Erro ao criar folga:", error);

            const status = error.response?.status;

            if (status === 401 || status === 403) {
                navigate("/login");
                return;
            }

            setMensagem(
                error.response?.data?.error ||
                error.response?.data?.message ||
                "Não foi possível criar a folga. Tente novamente."
            );
            setTipoMensagem("erro");
        } finally {
            setCarregando(false);
        }
    };

    return (
        <main className="criar-folga-page">
            <section className="criar-folga-card">
                <header className="criar-folga-header">
                    <div className="criar-folga-icon">
                        <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            aria-hidden="true"
                        >
                            <rect
                                x="3.5"
                                y="5"
                                width="17"
                                height="15.5"
                                rx="3"
                                stroke="currentColor"
                                strokeWidth="1.7"
                            />
                            <path
                                d="M7.5 3.5V7M16.5 3.5V7M3.5 9.5H20.5"
                                stroke="currentColor"
                                strokeWidth="1.7"
                                strokeLinecap="round"
                            />
                            <path
                                d="M8.5 14L10.5 16L15.5 12"
                                stroke="currentColor"
                                strokeWidth="1.7"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>

                    <div className="criar-folga-header-text">
                        <span className="criar-folga-eyebrow">
                            GESTÃO DE EQUIPE
                        </span>
                        <h1>Criar folga</h1>
                        <p>
                            Organize os dias de descanso da sua equipe
                            de forma simples.
                        </p>
                    </div>
                </header>

                <div className="criar-folga-divider" />

                <form className="criar-folga-form" onSubmit={handleSubmit}>
                    <div className="criar-folga-section-title">
                        <span className="criar-folga-step">01</span>
                        <div>
                            <h2>Detalhes da folga</h2>
                            <p>Informe quando e para quem será a folga.</p>
                        </div>
                    </div>

                    <div className="criar-folga-field">
                        <label htmlFor="data">
                            Data da folga
                            <span className="criar-folga-required">*</span>
                        </label>

                        <div className="criar-folga-input-wrapper">
                            <svg
                                className="criar-folga-field-icon"
                                viewBox="0 0 24 24"
                                fill="none"
                                aria-hidden="true"
                            >
                                <rect
                                    x="3.5"
                                    y="5"
                                    width="17"
                                    height="15.5"
                                    rx="3"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                />
                                <path
                                    d="M7.5 3.5V7M16.5 3.5V7M3.5 9.5H20.5"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                    strokeLinecap="round"
                                />
                            </svg>

                            <input
                                type="date"
                                id="data"
                                value={data}
                                min={(() => {
                                    const hoje = new Date();
                                    return `${hoje.getFullYear()}-${String(
                                        hoje.getMonth() + 1
                                    ).padStart(2, "0")}-${String(
                                        hoje.getDate()
                                    ).padStart(2, "0")}`;
                                })()}
                                onChange={(event) => setData(event.target.value)}
                                required
                                disabled={carregando}
                            />
                        </div>

                        <span className="criar-folga-hint">
                            A data deve ser hoje ou um dia futuro.
                        </span>
                    </div>

                    <div className="criar-folga-field">
                        <label htmlFor="funcionario">
                            Funcionário
                        </label>

                        <div className="criar-folga-input-wrapper">
                            <svg
                                className="criar-folga-field-icon"
                                viewBox="0 0 24 24"
                                fill="none"
                                aria-hidden="true"
                            >
                                <circle
                                    cx="12"
                                    cy="8"
                                    r="3.5"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                />
                                <path
                                    d="M5 20V18.5C5 15.74 7.24 13.5 10 13.5H14C16.76 13.5 19 15.74 19 18.5V20"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                    strokeLinecap="round"
                                />
                            </svg>

                            <select
                                id="funcionario"
                                value={funcionarioId}
                                onChange={(event) =>
                                    setFuncionarioId(event.target.value)
                                }
                                disabled={carregandoFuncionarios || carregando}
                            >
                                <option value="">
                                    Todos os funcionários
                                </option>

                                {funcionarios.map((funcionario) => (
                                    <option
                                        key={funcionario.id}
                                        value={funcionario.id}
                                    >
                                        {funcionario.nome}
                                    </option>
                                ))}
                            </select>

                            {carregandoFuncionarios && (
                                <span className="criar-folga-select-loading">
                                    <span className="criar-folga-spinner" />
                                </span>
                            )}
                        </div>

                        <span className="criar-folga-hint">
                            Deixe em “Todos os funcionários” para registrar
                            uma folga geral.
                        </span>
                    </div>

                    <div className="criar-folga-info">
                        <span className="criar-folga-info-icon">i</span>
                        <p>
                            <strong>Atenção:</strong> ao selecionar todos os
                            funcionários, a folga será enviada sem um
                            funcionário específico.
                        </p>
                    </div>

                    {mensagem && (
                        <div
                            className={`criar-folga-alert ${
                                tipoMensagem === "sucesso"
                                    ? "criar-folga-alert-success"
                                    : "criar-folga-alert-error"
                            }`}
                            role="status"
                            aria-live="polite"
                        >
                            <span className="criar-folga-alert-icon">
                                {tipoMensagem === "sucesso" ? "✓" : "!"}
                            </span>
                            <p>{mensagem}</p>
                            <button
                                type="button"
                                className="criar-folga-alert-close"
                                onClick={() => {
                                    setMensagem("");
                                    setTipoMensagem("");
                                }}
                                aria-label="Fechar mensagem"
                            >
                                ×
                            </button>
                        </div>
                    )}

                    <div className="criar-folga-actions">
                        <button
                            type="button"
                            className="criar-folga-btn criar-folga-btn-secondary"
                            onClick={() => navigate("/dashboard")}
                            disabled={carregando}
                        >
                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                aria-hidden="true"
                            >
                                <path
                                    d="M19 12H5M12 19L5 12L12 5"
                                    stroke="currentColor"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            Voltar
                        </button>

                        <button
                            type="submit"
                            className="criar-folga-btn criar-folga-btn-primary"
                            disabled={carregando || carregandoFuncionarios}
                        >
                            {carregando ? (
                                <>
                                    <span className="criar-folga-spinner criar-folga-spinner-light" />
                                    Criando folga...
                                </>
                            ) : (
                                <>
                                    Criar folga
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        aria-hidden="true"
                                    >
                                        <path
                                            d="M5 12H19M12 5L19 12L12 19"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </>
                            )}
                        </button>
                    </div>
                </form>

                <footer className="criar-folga-footer">
                    <span className="criar-folga-footer-dot" />
                    Cronos Agenda · Gestão simplificada
                </footer>
            </section>
        </main>
    );
};

export default CriarFolga;
